import { render, staticRenderFns } from "./trademarkReg.vue?vue&type=template&id=2d870de4"
import script from "./trademarkReg.vue?vue&type=script&lang=js"
export * from "./trademarkReg.vue?vue&type=script&lang=js"
import style0 from "./trademarkReg.vue?vue&type=style&index=0&id=2d870de4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports